import type { KLineData } from "klinecharts";

/**
 * Placeholder KLine indicator for custom scripts — legend name only, no plotted values.
 */
export function createCustomNoOpTemplate(displayName: string) {
  return {
    name: displayName,
    shortName: displayName,
    calcParams: [] as unknown[],
    series: "normal" as const,
    figures: [] as { key: string; title: string; type: string }[],
    styles: { lines: [] as unknown[] },
    calc: (dataList: KLineData[]) =>
      dataList.map(() => ({} as Record<string, never>)),
  };
}

export function isCustomIndicatorId(indicatorId: string): boolean {
  return indicatorId.startsWith("custom_");
}
